import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import Select from '@material-ui/core/Select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Card, CardContent, TextField } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { CommonConfig } from '../../config/common-config';
import './itecstyles.css';
import ButtonComp from '../../components/button';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';
import moment from 'moment';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PreviewImage from '../../assets/previewImage.png';
import PreviewModal from '../../components/modal/previewModal';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    pad: {
        paddingBottom: '30px',
        paddingLeft: '0',
        '&:last-child': {
            paddingBottom: '0px',
        },
    },
    textField: {
        borderBottom: '1px solid lightgrey !important',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '20px',
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
}));

export default function UpdateItec(props) {
    const [allRadios, setAllRadios] = useState([]);
    const [allStates, setAllStates] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const imcclients = useSelector((state) => state.users.imcClients);
    const rows = imcclients && imcclients.content;
    const [deletedata, setDeleteData] = useState(rows);
    const addressid = location.state.row.adressId;
    const editedvalues = location.state.row;
    const designationid = location.state.row.designation;
    const [errorDetails, seterrorDetails] = useState('');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [empRoles, setEmpRoles] = useState([]);
    const classes = useStyles();
    const [coreTeam, setCoreTeam] = useState([]);
    const [coreTeamRoles, setCoreTeamRoles] = useState([]);
    const coreRoleslist = [];
    const option = [];
    const [allCities, setAllCities] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountry, setselectedCountry] = useState(addressid.country);
    const [selectedStateId, setselectedStateId] = useState(addressid.stateId.id);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;

    const [handleOpenPan, setHandleOpenPan] = useState(false);
    const [clearDataPan, setClearDataPan] = useState('');
    const [isfileInvalidPan, setIsfileInvalidPan] = useState('');
    const [selectedFileDataPan, setSelectedFileDataPan] = useState(null);
    const [filenamePan, setFilenamePan] = useState('');
    const [uploadSuccessfullyPan, setUploadSuccessfullyPan] = useState('');
    const [isDisablePan, setIsDisablePan] = useState(true);
    const [URLValuePan, setURLValuePan] = useState();

    const [handleOpenAadhar, setHandleOpenAadhar] = useState(false);
    const [clearDataAadhar, setClearDataAadhar] = useState('');
    const [isfileInvalidAadhar, setIsfileInvalidAadhar] = useState('');
    const [selectedFileDataAadhar, setSelectedFileDataAadhar] = useState(null);
    const [filenameAadhar, setFilenameAadhar] = useState('');
    const [uploadSuccessfullyAadhar, setUploadSuccessfullyAadhar] = useState('');
    const [isDisableAadhar, setIsDisableAadhar] = useState(true);
    const [URLValueAadhar, setURLValueAadhar] = useState();

    const [attachedFilePan, setAttachedFilePan] = useState('');
    const [attachedFileAadhar, setAttachedFileAadhar] = useState('');
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');

    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, axiosConfig)
            .then((response) => {
                setAllCountries(response.data);
            })
            .catch(() => {});
    };
    const fetchStateData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/country/${data}/getStates`, axiosConfig)
            .then((response) => {
                setAllStates(response.data);
            })
            .catch(() => {});
    };
    const fetchCityData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/state/${data}/getCities`, axiosConfig)
            .then((response) => {
                setAllCities(response.data);
            })
            .catch(() => {});
    };
    const fetchStateId = (country, state) => {
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/state-country/${dbname}?state=${state}&country=${country}`, '', axiosConfig)
            .then((response) => {
                setselectedStateId(response.data.state.id);
            });
    };
    const setCountry = (e) => {
        setselectedCountry(e.target.value);
        fetchStateData(e.target.value);
    };
    const setState = (e) => {
        fetchCityData(e.target.value);
        fetchStateId(selectedCountry, e.target.value);
    };

    const handleClose = () => {
        setShowBtnLoader(false);
    };

    //format date function
    function reformatDateString(s) {
        var b = s.split(/\D/);
        return b.reverse().join('-');
    }

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const handleClosePan = () => {
        setHandleOpenPan(false);
        setIsfileInvalidPan('');
        setUploadSuccessfullyPan('');
    };
    const handleClickPan = () => {
        setHandleOpenPan(true);
        setFilenamePan('');
        setClearDataPan('');
        setIsDisablePan(true);
    };
    const isFileUploadPan = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenamePan(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidPan('');
                setIsDisablePan(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidPan('Please select the file size less than 10MB');
                    setIsDisablePan(true);
                } else {
                    setSelectedFileDataPan(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidPan('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisablePan(true);
            }
        }
    };
    const fileUploadPan = () => {
        const data = new FormData();
        data.append('file', selectedFileDataPan);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValuePan(response.data);
                    setAttachedFilePan(filenamePan);
                    setUploadSuccessfullyPan('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClosePan();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisablePan(true);
                }
            });
    };
    const handleCloseAadhar = () => {
        setHandleOpenAadhar(false);
        setIsfileInvalidAadhar('');
        setUploadSuccessfullyAadhar('');
    };
    const handleClickAadhar = () => {
        setHandleOpenAadhar(true);
        setClearDataAadhar('');
        setFilenameAadhar('');
        setIsDisableAadhar(true);
    };
    const isFileUploadAadhar = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameAadhar(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidAadhar('');
                setIsDisableAadhar(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidAadhar('Please select the file size less than 10MB');
                    setIsDisableAadhar(true);
                } else {
                    setSelectedFileDataAadhar(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidAadhar('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableAadhar(true);
            }
        }
    };
    const fileUploadAadhar = () => {
        const data = new FormData();
        data.append('file', selectedFileDataAadhar);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValueAadhar(response.data);
                    setAttachedFileAadhar(filenameAadhar);
                    setUploadSuccessfullyAadhar('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseAadhar();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableAadhar(true);
                }
            });
    };

    const formik = useFormik({
        initialValues: {
            firstname: editedvalues.firstName,
            lastname: editedvalues.lastName,
            fathersname: editedvalues.fathersName,
            gender: editedvalues.gender,
            dob: editedvalues.dateOfBirth,
            addressline1: addressid.addressLine1,
            addressline2: addressid.addressLine2,
            city: addressid.city,
            state: addressid.stateId.stateName,
            country: addressid.country,
            pin: addressid.pinCode,
            emergencynumber: editedvalues.emergencyNumber,
            pan: editedvalues.pan,
            personalemail: editedvalues.personalEmail,
            mobilenumber: editedvalues.mobileNumber,
            aadharnumber: editedvalues.aadharNumber,
            officemailid: editedvalues.officeEmail,
            branch: editedvalues.branch,
            timeSheetApprover: editedvalues.approverForTimesheet,
            doj: reformatDateString(editedvalues.doj),
            confirmationdate: editedvalues.confirmationDate,
            designation: designationid.roleId,
        },
        validationSchema: Yup.object().shape({
            firstname: Yup.string()
                // .matches(/^[aA-zZ]+$/, 'Enter only letters')
                .label('FirstName')
                .required('Required Field'),
            lastname: Yup.string()
                // .matches(/^[aA-zZ]+$/, 'Enter only letters')
                .label('LastName')
                .required('Required Field'),
            fathersname: Yup.string()
                // .matches(/^[aA-zZ]+$/, 'Enter only letters')
                .label('FathersName')
                .required('Required Field'),
            gender: Yup.string().required('Please Select'),
            dob: Yup.date()
                .required('Please Enter your Date Of Birth')
                .max(new Date(), 'Date of Birth should not be a future date')
                .test('dob', 'You must be 18 or older', (dobValue) => {
                    const cutOff = new Date();
                    cutOff.setFullYear(cutOff.getFullYear() - 18);
                    return dobValue <= cutOff;
                }),
            addressline1: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            addressline2: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            city: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a Valid City')
                .required('Required Field'),
            state: Yup.string().ensure().required('State Required Field'),
            country: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a Valid Country')
                .required('Required Field'),
            pin: Yup.string()
                .matches(/^\d{4,6}$/, 'Enter a valid PIN')
                .required('Please enter your PinCode'),
            emergencynumber: Yup.string()
                // .matches(/^[0-9]{10,12}$/, 'Enter vaild mobile number')
                .matches(/^\+[1-9]{1}[0-9]{7,11}$/, 'Enter vaild mobile number with valid Country code')
                .required('Enter Mobile Number'),
            pan: Yup.string()
                .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter Valid PAN')
                .required('PAN is Mandatory'),
            personalemail: Yup.string()
                .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
                .email('Invalid Email Format')
                .required('Required Field'),
            mobilenumber: Yup.string()
                // .matches(/^[0-9]{10,12}$/, 'Enter vaild mobile number')
                .matches(/^\+[1-9]{1}[0-9]{7,11}$/, 'Enter vaild mobile number with valid Country code')
                .required('Mobile number is Mandatory'),
            aadharnumber: Yup.string()
                .matches(/^\d{4}\d{4}\d{4}$/, 'Enter Valid 12 digit Aadhaar Number')
                .required('Aadhaar Number is Mandatory'),
            officemailid: Yup.string()
                .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
                .email('Invalid email format')
                .required('Required Field'),
            branch: Yup.string(),
            // .matches(/^[A-z0-9 ]+$/i, 'Enter a Valid branch Name')
            // .min('2', 'Please Enter atleast 2 words')
            // .required('Required Field'),
            designation: Yup.string().required('Please Select One Of Designations'),
            timeSheetApprover: Yup.string().required('Please select Approver'),
            doj: Yup.date().required('Please Enter Date Of Joining'),
            confirmationdate: Yup.date().min(Yup.ref('doj'), 'Confirmation date should not be prior to date of joining'),
            // .max(Yup.ref('doj'), 'Should Match Date Of Joining')
            // .required('Confirm Date Of Joining'),
        }),
        onSubmit: (values) => {
            setShowBtnLoader(true);
            const data = {
                itecEmpId: location.state.row.itecEmpId,
                userId: location.state.row.userId,
                isActive: location.state.row.isActive,
                firstName: values.firstname,
                adressId: {
                    addressLine1: values.addressline1,
                    addressLine2: values.addressline2,
                    city: values.city,
                    stateId: {
                        id: Number(selectedStateId),
                    },
                    pinCode: values.pin,
                    country: values.country,
                },
                pan: values.pan,
                aadharNumber: values.aadharnumber,
                lastName: values.lastname,
                officeEmail: values.officemailid,
                mobileNumber: values.mobilenumber,
                fathersName: values.fathersname,
                gender: values.gender,
                dateOfBirth: values.dob,
                personalEmail: values.personalemail,
                doj: values.doj,
                confirmationDate: values.confirmationdate,
                branch: values.branch,
                designation: {
                    roleId: Number(values.designation),
                },
                emergencyNumber: values.emergencynumber,
                approverForTimesheet: values.timeSheetApprover,
                panFiles: URLValuePan && URLValuePan.length ? URLValuePan : '',
                aadhaarFiles: URLValueAadhar && URLValueAadhar.length ? URLValueAadhar : '',
            };
            axios
                .put(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee`, data, axiosConfig)
                .then((response) => {
                    setShowBtnLoader(false);
                    setSuccess(true);
                    setDeleteData(data);
                    setTimeout(() => {
                        history.push({
                            pathname: '/menu/itechView',
                            deletedata,
                        });
                    }, 3000);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowBtnLoader(false);
                        setError(true);
                        setTimeout(() => {
                            setError(false);
                        }, 5000);
                        seterrorDetails(errResult.data.message);
                    }
                });
        },
    });

    useEffect(() => {
        if (location.state.row) {
            setAttachedFilePan(
                location.state.row &&
                    location.state.row.panFiles &&
                    location.state.row.panFiles.substring(location.state.row.panFiles.lastIndexOf('/') + 1)
            );
            setAttachedFileAadhar(
                location.state.row &&
                    location.state.row.aadhaarFiles &&
                    location.state.row.aadhaarFiles.substring(location.state.row.aadhaarFiles.lastIndexOf('/') + 1)
            );

            setURLValuePan(location.state.row && location.state.row.panFiles);
            setURLValueAadhar(location.state.row && location.state.row.aadhaarFiles);
        }

        let country = null;
        let state = null;
        fetchCountryData();
        setTimeout(() => {
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/get-all-designation/`, axiosConfig)
                .then(async (response) => {
                    setAllRadios(response.data);
                    await response.data.map((ele, i) => {
                        if (ele.roleId <= 8) {
                            coreRoleslist.push(ele);
                            setCoreTeamRoles(coreRoleslist);
                        }
                    });

                    await axios
                        .get(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee?page=0&size=1000&sort=itecEmpId,desc`, axiosConfig)
                        .then((response) => {
                            if (response) setCoreTeam(response.data.content);
                            getRoles(coreRoleslist, response.data.content);
                        })
                        .catch(() => {});
                    country = addressid.country;
                    state = addressid.stateId.stateName;

                    if (country !== null && state !== null) {
                        fetchStateData(country);
                        fetchCityData(state);
                    }
                })
                .catch(() => {});
        }, 1000);

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-itecAMandAbove`, axiosConfig)
            .then((response) => {
                if (response) setEmpRoles(response.data);
            })
            .catch(() => {});
    }, [bearerToken]);

    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const allStateOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.state_name}>{data.state_name}</option>);
        return OptionList;
    };
    const allCityOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.city_name}>{data.city_name}</option>);
        return OptionList;
    };
    const allRadioOptions = (qq, designation) => {
        const radioList = qq.map((number) => (
            <Grid item xs={12} sm={3} className={classes.pad}>
                <input
                    id={number.roleId}
                    type="radio"
                    value={number.roleId}
                    name="designation"
                    onChange={formik.handleChange}
                    defaultChecked={formik.values.designation === number.roleId}
                />
                <label className="custom-control-label" htmlFor={number.roleId}>
                    {number.roleText}
                </label>
            </Grid>
        ));

        return <div className="itecdesg-radiosdiv">{radioList}</div>;
    };

    const getRoles = () => {};

    const allCoreEmployeeOptions = () => {
        if (empRoles) {
            const OptionList = empRoles.map((data) => (
                <option value={data.id + ' - ' + data.firstName + ' ' + data.lastName}>
                    {data.id} - {data.firstName} {data.lastName}
                </option>
            ));
            return OptionList;
        }
    };

    const back = () => {
        props.history.push('/menu/itechView');
    };

    return (
        <>
            {success ? (
                <SuccessPopUp open={success} showSuccess={success} handleClose={handleClose} title="ITeC employee updated successfully" />
            ) : null}
            {error ? <ErrorPopUp open={error} showError={error} handleClose={handleClose} title={errorDetails} /> : null}

            <form onSubmit={formik.handleSubmit}>
                <Card className="client-card">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Update ITec Employee Details</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="firstName" shrink disabled>
                                        First Name
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        disabled
                                        id="first-name"
                                        name="firstName"
                                        placeholder="First Name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.firstname}
                                    />
                                    {formik.touched.firstname && formik.errors.firstname ? (
                                        <span className="itec-validationError">{formik.errors.firstname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="lastname" shrink disabled>
                                        Last Name
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        disabled
                                        name="lastname"
                                        placeholder="Last Name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.lastname}
                                    />
                                    {formik.touched.lastname && formik.errors.lastname ? (
                                        <span className="itec-validationError">{formik.errors.lastname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="fathersname" shrink>
                                        Father&apos;s Name
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="fathersname"
                                        placeholder="Father's Name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.fathersname}
                                    />
                                    {formik.touched.fathersname && formik.errors.fathersname ? (
                                        <span className="itec-validationError">{formik.errors.fathersname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label className="labelCls">Gender</label>
                                <ul className="genderli">
                                    <li>
                                        <div className="custom-control">
                                            <input
                                                id="male"
                                                type="radio"
                                                value="male"
                                                name="gender"
                                                onChange={formik.handleChange}
                                                defaultChecked={formik.values.gender === 'male'}
                                            />
                                            <label className="custom-control-label" htmlFor="male">
                                                Male
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="custom-control">
                                            <input
                                                id="female"
                                                type="radio"
                                                value="female"
                                                name="gender"
                                                onChange={formik.handleChange}
                                                defaultChecked={formik.values.gender === 'female'}
                                            />
                                            <label className="custom-control-label" htmlFor="female">
                                                Female
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                                {formik.touched.gender && formik.errors.gender ? (
                                    <span className="itec-validationError">{formik.errors.gender}</span>
                                ) : null}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="dob" shrink>
                                        {' '}
                                        Date of Birth
                                    </InputLabel>
                                    <TextField
                                        type="date"
                                        name="dob"
                                        margin="normal"
                                        format="YYYY/MM/DD"
                                        className={classes.textField}
                                        placeholder="Date Of Birth"
                                        // inputProps={{ max: "9999-12-31" } }
                                        InputProps={{ inputProps: { max: moment(new Date()).format('DD-MM-YYYY') } }}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.dob}
                                    />
                                    {formik.touched.dob && formik.errors.dob ? (
                                        <span className="itec-validationError">{formik.errors.dob}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="addressline1" shrink>
                                        Address line 1
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="addressline1"
                                        placeholder="Address line 1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline1}
                                    />
                                    {formik.touched.addressline1 && formik.errors.addressline1 ? (
                                        <span className="itec-validationError">{formik.errors.addressline1}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="addressline2" shrink>
                                        Address line 2
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="addressline2"
                                        placeholder="Address line 2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline2}
                                    />
                                    {formik.touched.addressline2 && formik.errors.addressline2 ? (
                                        <span className="itec-validationError">{formik.errors.addressline2}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="country" shrink>
                                        {' '}
                                        Country
                                    </InputLabel>
                                    <Select
                                        native
                                        onChange={(e) => {
                                            setCountry(e);
                                            formik.handleChange(e);
                                        }}
                                        name="country"
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                        value={formik.values.country}
                                    >
                                        <option value="">Select Country</option>
                                        {allCountryOptions(allCountries)}
                                    </Select>
                                    {formik.touched.country && formik.errors.country ? (
                                        <span className="itec-validationError">{formik.errors.country}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="state" shrink>
                                        {' '}
                                        State
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="state"
                                        value={formik.values.state}
                                        onChange={(e) => {
                                            setState(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select State</option>
                                        {allStateOptions(allStates)}
                                    </Select>
                                    {formik.touched.state && formik.errors.state ? (
                                        <span className="itec-validationError">{formik.errors.state}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="city" shrink>
                                        {' '}
                                        City
                                    </InputLabel>

                                    <Select
                                        native
                                        name="city"
                                        className="bottom"
                                        value={formik.values.city}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select City</option>
                                        {allCityOptions(allCities)}
                                    </Select>
                                    {formik.touched.city && formik.errors.city ? (
                                        <span className="itec-validationError">{formik.errors.city}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="pin" shrink>
                                        Pin
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="pin"
                                        placeholder="Pin"
                                        maxLength="6"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pin}
                                    />
                                    {formik.touched.pin && formik.errors.pin ? (
                                        <span className="itec-validationError">{formik.errors.pin}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="emergencynumber" shrink>
                                        Emergency Number
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="emergencynumber"
                                        placeholder="Emergency Number"
                                        maxLength="13"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.emergencynumber}
                                    />
                                    {formik.touched.emergencynumber && formik.errors.emergencynumber ? (
                                        <span className="itec-validationError">{formik.errors.emergencynumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="pan" shrink>
                                        PAN
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="pan"
                                        placeholder="PAN"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pan}
                                    />
                                    <div className={classes.btnFieldPositionRight}>
                                        <span style={{ marginRight: '7px' }} className="fileName">
                                            {attachedFilePan}
                                        </span>
                                        {attachedFilePan ? (
                                            <span onClick={() => handlePreviewModal(URLValuePan)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <Button onClick={handleClickPan} variant="outlined" color="primary" className={classes.uploadBtn}>
                                            Upload
                                        </Button>
                                        <Dialog
                                            onClose={handleClosePan}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenPan}
                                            clear={clearDataPan}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                aria-label="close"
                                                className={classes.closeButton}
                                                onClick={handleClosePan}
                                            >
                                                <CloseIcon />
                                            </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadPan(e, e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                <p className="fileName">{filenamePan}</p>
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyPan}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisablePan ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadPan}
                                                    variant="contained"
                                                    disabled={isDisablePan}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={handleClosePan}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                    {formik.touched.pan && formik.errors.pan ? (
                                        <span className="itec-validationError">{formik.errors.pan}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="personalemail" shrink>
                                        Personal E-mail
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="personalemail"
                                        placeholder="Personal E-mail"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.personalemail}
                                    />
                                    {formik.touched.personalemail && formik.errors.personalemail ? (
                                        <span className="itec-validationError">{formik.errors.personalemail}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="mobilenumber" shrink>
                                        Mobile Number
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="mobilenumber"
                                        placeholder="Mobile Number"
                                        maxLength="13"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.mobilenumber}
                                    />
                                    {formik.touched.mobilenumber && formik.errors.mobilenumber ? (
                                        <span className="itec-validationError">{formik.errors.mobilenumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="aadharnumber" shrink>
                                        Aadhaar Number
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="aadharnumber"
                                        placeholder="Aadhaar Number"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.aadharnumber}
                                    />
                                    <div className={classes.btnFieldPositionRight}>
                                        <span style={{ marginRight: '7px' }}>{attachedFileAadhar}</span>
                                        {attachedFileAadhar ? (
                                            <span onClick={() => handlePreviewModal(URLValueAadhar)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <label htmlFor="raised-button-file">
                                            <Button
                                                onClick={handleClickAadhar}
                                                // variant="raised"
                                                // component="span"
                                                color="primary"
                                                variant="outlined"
                                                className={classes.uploadBtn}
                                                // endIcon={<AttachFileIcon />}
                                            >
                                                Upload
                                            </Button>
                                        </label>

                                        <Dialog
                                            onClose={handleCloseAadhar}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenAadhar}
                                            clear={clearDataAadhar}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                            aria-label="close"
                                                            className={classes.closeButton}
                                                            onClick={handleCloseAadhar}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadAadhar(e, e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                <p className="fileName">{filenameAadhar}</p>
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyAadhar}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisableAadhar ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadAadhar}
                                                    variant="contained"
                                                    disabled={isDisableAadhar}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={handleCloseAadhar}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                    {formik.touched.aadharnumber && formik.errors.aadharnumber ? (
                                        <span className="itec-validationError">{formik.errors.aadharnumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="officemailid" shrink>
                                        Official Email-Id
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        disabled
                                        className={classes.bottomLine}
                                        name="officemailid"
                                        placeholder="Office Mail-Id"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.officemailid}
                                    />
                                    {formik.touched.officemailid && formik.errors.officemailid ? (
                                        <span className="itec-validationError">{formik.errors.officemailid}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="branch" shrink>
                                        Branch
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        className={classes.bottomLine}
                                        name="branch"
                                        placeholder="Branch"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.branch}
                                    />
                                    {formik.touched.branch && formik.errors.branch ? (
                                        <span className="itec-validationError">{formik.errors.branch}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="timeSheetApprover" shrink>
                                        Approver for Timesheet, Leaves, Time in-out
                                    </InputLabel>
                                    <Select
                                        native
                                        // variant="filled"
                                        name="timeSheetApprover"
                                        defaultValue={formik.values.timeSheetApprover}
                                        value={formik.values.timeSheetApprover}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        // onClick={ }
                                        className="bottom"
                                    >
                                        <option value="">Select Approver</option>
                                        {allCoreEmployeeOptions()}
                                        {/* {approverList} */}
                                    </Select>
                                    {formik.touched.timeSheetApprover && formik.errors.timeSheetApprover ? (
                                        <span className="itec-validationError">{formik.errors.timeSheetApprover}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="doj" shrink>
                                        DOJ
                                    </InputLabel>
                                    <Input
                                        id="doj"
                                        name="doj"
                                        type="date"
                                        format="YYYY/MM/DD"
                                        className="bottom"
                                        inputProps={{ max: '9999-12-31' }}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.doj}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.doj && formik.errors.doj ? (
                                        <span className="itec-validationError">{formik.errors.doj}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="confirmationdate" shrink>
                                        Confirmation Date
                                    </InputLabel>
                                    <Input
                                        id="confirmationdate"
                                        name="confirmationdate"
                                        type="date"
                                        className="bottom"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.confirmationdate}
                                        inputProps={{ max: '9999-12-31' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.confirmationdate && formik.errors.confirmationdate ? (
                                        <span className="itec-validationError">{formik.errors.confirmationdate}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <div className="designdiv">
                                        <div className="designtext">Designation</div>
                                    </div>
                                </FormControl>
                                <div className="itecform-radiodiv">
                                    <div className="itecradiosmaindiv">
                                        {allRadioOptions(allRadios)}
                                        {formik.touched.designation && formik.errors.designation ? (
                                            <span className="itec-validationError">{formik.errors.designation}</span>
                                        ) : null}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid>
                    <div className="footer-button">
                        <ul>
                            <li>
                                <ButtonComp className="intermediarybutn" title="Back" onClick={() => back()} />
                            </li>
                            <li>
                                <div className="errorMsgRed">{error}</div>
                                {(showBtnLoader ? (
                                    <LoaderPopUp
                                        showLoader={showBtnLoader}
                                        handleClose={handleClose}
                                        title="Please wait while we update the employee"
                                    />
                                ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Update ITeC Employee" />}
                            </li>
                        </ul>
                    </div>
                    <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
                    {showBtnLoader ? (
                        <LoaderPopUp
                            showLoader={showBtnLoader}
                            handleClose={handleClose}
                            title="Please wait while approving Draft Statements"
                        />
                    ) : null}
                </Grid>
            </form>
        </>
    );
}
